import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  RestrictUserTypeRolePermissionValue,
  RolePermissionKey,
} from '@/modules/ta/role/role.constants';

export class RoleRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      !(
        userSettings.getPermission(Module.ROLE, RolePermissionKey.CAN_ACCESS_ROLES) ===
          RestrictUserTypeRolePermissionValue.BELOW && userSettings.isClient()
      ) && super.canAccessRouteFromContext()
    );
  }
}
